import { Helmet } from "react-helmet-async";

const BRAND = "Hannah Howard Funding";
const DEFAULT_DESC =
  "Fast real estate commission advances. No credit check. Same-day review. Up to 75% of your pending commission.";

// GA4 measurement ID — configured at build time via env var. When absent,
// the site simply renders without analytics (fail-open).
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

export default function SEO({ title, description = DEFAULT_DESC, path }) {
  const fullTitle = title ? `${title} — ${BRAND}` : `${BRAND} — Fast Real Estate Commission Advances`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {path ? <link rel="canonical" href={`https://hannahhowardfunding.com${path}`} /> : null}
      {GA_ID ? (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}></script>
      ) : null}
      {GA_ID ? (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}', { anonymize_ip: true });
        `}</script>
      ) : null}
    </Helmet>
  );
}
